import { ActionColumnFormat } from './ColumnsFormatters/ActionColumnFormat';

export const columnsNotify = (onCheckbox, all) => [
	{
		dataField: 'sector',
		text: 'Representación',
		classes: 'text-center',
	},
	{
		dataField: 'name',
		text: 'Miembro',
		classes: 'text-center',
	},
	{
		dataField: 'position',
		text: 'Cargo',
		classes: 'text-center',
	},
	{
		dataField: 'id',
		text: 'Acciones',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnFormat,
		formatExtraData: {
			onCheckbox,
			all,
		},
	},
];
